import React, {useRef} from "react";

import { TbTools } from "react-icons/tb";
import { MdOutlineCases } from "react-icons/md";
import { GrUserManager } from "react-icons/gr";
import { PiStudentBold } from "react-icons/pi";
import { BiConversation } from "react-icons/bi";
import { FaRegHeart } from "react-icons/fa";

import kv1 from "../../img/1000_1.jpg";
import xray from "../../img/xray-adw.jpg";
import Awarding from "../awarding/awarding";

import ScrollAnimation from 'react-animate-on-scroll';
import 'animate.css';

function AdvantagesOne({advantagesData, awardingData}) {

    return (
        <section className="relative py-0 overflow-hidden">
            <div className="panel overflow-hidden relative py-40 z-30 flex justify-center items-center bg-[#8cc9ff]">
                <div className="relative z-30 md:bg-[#8cc9ff] bg-[#8cc9ff]/80 p-5 advantages w-full max-w-[600px]" id="adv_text">
                    <ScrollAnimation animatePreScroll="true" offset="100"
                                     animateIn="animate__fadeInLeft">
                        <h2 className="text-4xl mb-4 uppercase relative z-20">{advantagesData?.advantages_title}</h2>

                    {
                        advantagesData?.advantages_repeater ?
                            advantagesData.advantages_repeater.map((item, value) => (

                                <div className="flex items-center mb-4"
                                     key={value} id={'img' + value}>
                                    <div className="relative z-20 mr-4 ">
                                        {
                                            value === 0 ? <TbTools className="text-3xl "/> : ''
                                        }
                                        {
                                            value === 1 ? <GrUserManager className="text-3xl"/> : ''
                                        }
                                        {
                                            value === 2 ? <MdOutlineCases className="text-3xl"/> : ''
                                        }
                                        {
                                            value === 3 ? <PiStudentBold className="text-3xl"/> : ''
                                        }
                                        {
                                            value === 4 ? <BiConversation className="text-3xl"/> : ''
                                        }
                                        {
                                            value === 5 ? <FaRegHeart className="text-3xl"/> : ''
                                        }
                                    </div>
                                    <div>
                                        <h4 className="relative z-20">{item?.advantages_repeater_title}</h4>
                                        <p className="relative z-20">{item?.advantages_repeater_text}</p>
                                    </div>
                                </div>

                            )) : ''
                    }
                    </ScrollAnimation>

                </div>
                <ScrollAnimation
                    animatePreScroll="true"
                    offset="100"
                    animateIn="animate__fadeInRight"
                    className="md:w-1/2 w-10/12 max-w-6xl absolute right-0 top-0 z-10 block"
                >
                        <img src={kv1} />
                </ScrollAnimation>
                <div className="absolute left-0 top-8 text-[20vw] font-bold leading-[100%] text-[#78bdfa] z-10">
                    <div className="flex">
                        <ScrollAnimation animateIn="animate__fadeIn" delay={500} initiallyVisible={false}>M</ScrollAnimation>
                        <ScrollAnimation animateIn='animate__fadeIn' delay={1000} initiallyVisible={false}>R</ScrollAnimation>
                        <ScrollAnimation animateIn='animate__fadeIn' delay={1500} initiallyVisible={false}>K</ScrollAnimation>
                        <ScrollAnimation animateIn='animate__fadeIn' delay={2000} initiallyVisible={false}>T</ScrollAnimation>
                        <ScrollAnimation animateIn='animate__fadeIn' delay={2500} initiallyVisible={false}>N</ScrollAnimation>
                        <ScrollAnimation animateIn='animate__fadeIn' delay={3000} initiallyVisible={false}>G</ScrollAnimation>
                    </div>
                    <div className="flex">
                        <ScrollAnimation animateIn="animate__fadeIn" delay={500}
                                         initiallyVisible={false}>M</ScrollAnimation>
                        <ScrollAnimation animateIn='animate__fadeIn' delay={1000}
                                         initiallyVisible={false}>R</ScrollAnimation>
                        <ScrollAnimation animateIn='animate__fadeIn' delay={1500}
                                         initiallyVisible={false}>T</ScrollAnimation>
                        <ScrollAnimation animateIn='animate__fadeIn' delay={2000}
                                         initiallyVisible={false}>H</ScrollAnimation>
                        <ScrollAnimation animateIn='animate__fadeIn' delay={2500}
                                         initiallyVisible={false}>N</ScrollAnimation>
                    </div>
                </div>

            </div>

            <div className="overflow-hidden py-40 relative z-30 flex justify-center items-center bg-[#ff8048]">

                <ScrollAnimation
                    animatePreScroll="true"
                    offset="100"
                    animateIn="animate__fadeInLeft"
                    className="md:bg-[#ff8048] bg-[#ff8048]/80 p-5 relative z-30 w-full max-w-[600px]"
                >
                    <Awarding awardingData={awardingData}/>
                </ScrollAnimation>

                <ScrollAnimation
                    animatePreScroll="true"
                    offset="100"
                    animateIn="animate__fadeInRight"
                    className="block md:w-1/2 w-10/12 max-w-6xl absolute left-0 bottom-0 z-10"
                >
                    <img src={xray}/>
                </ScrollAnimation>

                <div className="absolute right-0 top-8 text-[30vw] font-bold leading-[100%] text-[#ff783d] z-10">
                    <div className="flex">
                        <ScrollAnimation animateIn="animate__fadeIn" delay={500} initiallyVisible={false}>X</ScrollAnimation>
                        <ScrollAnimation animateIn='animate__fadeIn' delay={1000} initiallyVisible={false}>-</ScrollAnimation>
                        <ScrollAnimation animateIn='animate__fadeIn' delay={1500} initiallyVisible={false}>R</ScrollAnimation>
                        <ScrollAnimation animateIn='animate__fadeIn' delay={2000} initiallyVisible={false}>A</ScrollAnimation>
                        <ScrollAnimation animateIn='animate__fadeIn' delay={2000} initiallyVisible={false}>Y</ScrollAnimation>
                    </div>
                </div>

            </div>


        </section>
    )
}

export default AdvantagesOne